import { render, staticRenderFns } from "./vr-list.vue?vue&type=template&id=533c9077&scoped=true"
import script from "./vr-list.vue?vue&type=script&lang=js"
export * from "./vr-list.vue?vue&type=script&lang=js"
import style0 from "./vr-list.vue?vue&type=style&index=0&id=533c9077&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c9077",
  null
  
)

export default component.exports